/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Extension_Herosubtitle1Inputs */

const he_extension_herosubtitle1 = /** @type {(inputs: Extension_Herosubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`היסטוריית מחירים מפורטת וסטטיסטיקות מתקדמות לכל המוצרים ב-KSP`)
};

const en_extension_herosubtitle1 = /** @type {(inputs: Extension_Herosubtitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Detailed price history and advanced statistics for all KSP products`)
};

/**
* | output |
* | --- |
* | "Detailed price history and advanced statistics for all KSP products" |
*
* @param {Extension_Herosubtitle1Inputs} inputs
* @param {{ locale?: "he" | "en" }} options
* @returns {LocalizedString}
*/
const extension_herosubtitle1 = /** @type {((inputs?: Extension_Herosubtitle1Inputs, options?: { locale?: "he" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Extension_Herosubtitle1Inputs, { locale?: "he" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "he") return he_extension_herosubtitle1(inputs)
	return en_extension_herosubtitle1(inputs)
});
export { extension_herosubtitle1 as "extension_heroSubtitle" }